module.exports = __webpack_public_path__ + "static/media/datepicker.bbd77604.svg";